// extracted by mini-css-extract-plugin
export var animated = "button-module--animated--111ff";
export var button = "button-module--button--50a6e";
export var cursorGradient = "button-module--cursorGradient--b3b6e";
export var full = "button-module--full--ecc88";
export var large = "button-module--large--059fa";
export var medium = "button-module--medium--e576a";
export var outline = "button-module--outline--7d6b9";
export var textgradient = "button-module--textgradient--d4d6f";